import React from 'react';
import { Container } from 'react-bootstrap';
import AppraisalList from '../components/AppraisalList';
import Layout from '../../../components/Layout';

const AppraisalListPage = () => {
  return (
    <Layout>
      <AppraisalList />
    </Layout>
  );
};

export default AppraisalListPage;
